export default {
  ES: 'España',
  FR: 'Francia',
  PT: 'Portugal',
  IT: 'Italia',
  AD: 'Andorra',
};
